import * as React from "react";
import { GoalItemsPanel } from "../GoalItemsPanel.js";
import { PlacementEngine } from "../PlacementEngine.js";
import type { GoalDetail } from "../types.js";

/**
 * PlacementGoalView — detail body for a "find a home" goal.
 *
 * Composes the shared items panel + the shared PlacementEngine. Owns the lifted
 * `showLinkItems` state so the engine's empty-state "Add items" button opens the
 * same modal the items panel uses (matching the old monolith UX). The items
 * panel is injected into the engine via `itemsSlot` so it renders in its
 * original position (between the "try a different spot" prompt and the trials
 * list).
 */
export function PlacementGoalView({
  goal,
  goalId,
  isOwner,
  onSetGoal,
  refetchGoal,
}: {
  goal: GoalDetail;
  goalId: string;
  isOwner: boolean;
  onSetGoal: (goal: GoalDetail) => void;
  refetchGoal: () => Promise<void> | void;
}) {
  const [showLinkItems, setShowLinkItems] = React.useState(false);

  return (
    <PlacementEngine
      goal={goal}
      goalId={goalId}
      isOwner={isOwner}
      refetchGoal={refetchGoal}
      onAddItems={() => setShowLinkItems(true)}
      itemsSlot={
        <GoalItemsPanel
          goal={goal}
          goalId={goalId}
          isOwner={isOwner}
          onSetGoal={onSetGoal}
          onItemsChanged={refetchGoal}
          showLinkItems={showLinkItems}
          setShowLinkItems={setShowLinkItems}
        />
      }
    />
  );
}
